import { formPatterns } from '../configs/form-patterns';

export const getPattern = (key: string) => formPatterns.find(p => p.key === key)?.pattern;
